import { NgModule } from "@angular/core";
import { FeatureFlagDirective } from "./directives/feature-flag/feature-flag.directive";
import { LabelPipe } from "./pipes/label/label.pipe";

@NgModule({
  declarations: [LabelPipe, FeatureFlagDirective],
  exports: [LabelPipe, FeatureFlagDirective],
})
export class ConfigModule {}
